import { Reducer } from 'redux';

// Actions

export const clearPrefilledOrderInputs = () => ({
  type: 'CLEAR_PREFILLED_ORDER_INPUTS' as const,
});

export const prefillOrderInputPrice = (price: string) => ({
  type: 'PREFILL_ORDER_INPUT_PRICE' as const,
  price,
});

export const prefillOrderInputQuantity = (amount: string) => ({
  type: 'PREFILL_ORDER_INPUT_QUANTITY' as const,
  amount,
});

type PrefillOrderInputsAction = ReturnType<
  | typeof prefillOrderInputPrice
  | typeof prefillOrderInputQuantity
  | typeof clearPrefilledOrderInputs
>;

// Reducer

interface PrefillOrderInputs {
  // buyOrSell?: 'buy' | 'sell';
  price?: string;
  quantity?: string;
  // For market orders, we need to store sum in quotes (price * q)
  // quoteSum?: string;
}

const defaultState: PrefillOrderInputs = {
  // buyOrSell: undefined,
  price: undefined,
  quantity: undefined,
};

export const prefillOrderInputsReducer: Reducer<
  PrefillOrderInputs,
  PrefillOrderInputsAction
> = (state = defaultState, action): PrefillOrderInputs => {
  switch (action.type) {
    case 'CLEAR_PREFILLED_ORDER_INPUTS':
      return defaultState;
    case 'PREFILL_ORDER_INPUT_PRICE':
      return {
        price: action.price,
      };
    case 'PREFILL_ORDER_INPUT_QUANTITY':
      return {
        quantity: action.amount,
      };
    default:
      return state;
  }
};
